import { useState } from 'react';
import { Button, Spinner, Avatar } from '@heroui/react';
import {
  Uniformly,
  ImageInputField,
  TextField,
  PhoneField,
  EmailField,
  FieldStatus,
} from '@livefree/uniformly';
import { BlobUtils } from '@livefree/common';
import { reactive } from '@/core/reactive/reactive';

export const ProfileForm = reactive.component(
  ({ user, services, monitors }) => {
    const [form, setForm] = useState(null);

    return user ? (
      <Uniformly
        className="flex flex-col w-full gap-4"
        onChange={async form => {
          if (form.data.logo instanceof Blob) {
            form.data.logo = await BlobUtils.toBase64(form.data.logo);
          }

          setForm(form);
        }}
      >
        <ImageInputField name="logo" label="Logo" defaultValue={user?.avatarUrl} hasDropzone>
          <ImageInputField.Preview>
            {image => (
              <div className="flex items-center justify-center">
                <Avatar size="lg" src={image} />
              </div>
            )}
          </ImageInputField.Preview>
        </ImageInputField>

        <FieldStatus required>
          <TextField
            id="displayName"
            name="displayName"
            label="Display name"
            variant="faded"
            value={user?.displayName}
            validation={x => x.string().required('Display name is required')}
          />
        </FieldStatus>
        <FieldStatus required>
          <TextField
            id="firstName"
            name="firstName"
            label="First name"
            variant="faded"
            value={user?.firstName}
            validation={x => x.string().required('First name is required')}
          />
        </FieldStatus>
        <FieldStatus required>
          <TextField
            id="lastName"
            name="lastName"
            label="Last name"
            variant="faded"
            value={user?.lastName}
            validation={x => x.string().required('Last name is required')}
          />
        </FieldStatus>
        <FieldStatus required>
          <EmailField
            id="email"
            name="email"
            label="Email"
            variant="faded"
            value={user?.email}
            validation={x => x.string().required('Email is required')}
          />
        </FieldStatus>
        <FieldStatus important>
          <PhoneField
            id="mobilePhone"
            name="mobilePhone"
            label="Mobile phone #"
            variant="faded"
            value={user?.mobilePhone}
          />
        </FieldStatus>
        <Button
          color="primary"
          isDisabled={!form?.isValid}
          isLoading={monitors.updateProfile.executing}
          onPress={() => services.my.updateProfile(user?.id, form?.data)}
        >
          Update profile
        </Button>
      </Uniformly>
    ) : (
      <Spinner />
    );
  },
  {
    name: 'ProfileForm',
    monitors: services => [services.my.updateProfile],
  },
);
